export const Actions = {
  requestResetPasswordLink: "requestResetPasswordLink",
  resetPassword: "resetPassword",
  requestEmailValidationLink: "requestEmailValidationLink",
  validateEmail: "validateEmail",
  checkScheduledTasks: "checkScheduledTasks",
  requestSigning: "requestSigning",
  checkSigning: "checkSigning",
  cloneMandates: "cloneMandates",
  cloneProgramMandates: "cloneProgramMandates",
  notifySignedContract: "notifySignedContract",
  exportHousingsAsCsv: "exportHousingsAsCsv",
  checkNotifying: "checkNotifying",
  requestAr24AccountAccess: "requestAr24AccountAccess",
};
